import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    LinearScale,
    Title,
    Tooltip,
} from "chart.js";
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { HOME, months } from "../../Utils/Utils";
import { COURBE, RECUPERER_DATA_COUNTER, RECUPERE_GRAPHE_CHIFFRE_AFFAIRE, RECUPERE_GRAPHE_INSTALLATION } from "../../Utils/constant";
import calendar from "../../assets/icons/calendar.svg";
import client from "../../assets/icons/client.svg";
import install from "../../assets/icons/install.svg";
import { Counter } from "../../components/Stats/Counter";
import { CounterSkeleton } from "../../components/Stats/CounterSkeleton";
import { Count } from "../../components/Widget/Count";
import { DateFilter } from "../../components/Widget/DateFilter";
import { getStat, getStatCounter, store } from '../../services/service';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip);

export const Home = () => {
    const [loadingData, setloadingData] = useState(true)
    const [dataCounter, setDataCounter] = useState(null);
    const [dataRDV, setDataRDV] = useState(null);
    const [grapheInstallation, setGrapheInstallation] = useState({
        data: {
            labels: months.map((item) => item.name),
            datasets: [
                {
                    label: "Nombre installation",
                    data: [59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55],
                    backgroundColor: "#ccccc",
                    borderColor: "white",
                    borderRadius: 3,
                    borderSkipped: false,
                },
            ],
        },
        options: {
            responsive: true,
            plugins: {
                title: {
                    display: true,
                    text: "",
                },
            },
            scales: {
                y: {
                    display: false,
                },
                xAxes: [
                    {
                        maxBarThickness: 100,
                    },
                ],
                x: {
                    grid: {
                        display: false,
                    },
                },
            },
        }
    });
    const [grapheChiffreAffaire, setGrapheChiffreAffaire] = useState({
        data: {
            labels: months.map((item) => item.name),
            datasets: [
                {
                    label: "Chiffre d'affaire",
                    data: [159, 800, 281, 856, 515, 140, 265, 159, 780, 181, 256, 455],
                    backgroundColor: "#fbbf24",
                    borderColor: "white",
                    borderRadius: 3,
                    borderSkipped: false,
                },
            ],
        },
        options: {
            responsive: true,
            plugins: {
                title: {
                    display: true,
                    text: "",
                },
            },
            scales: {
                y: {
                    display: false,
                },
                xAxes: [
                    {
                        maxBarThickness: 100,
                    },
                ],
                x: {
                    grid: {
                        display: false,
                    },
                },
            },
        }
    });

    const recupereCounterData = (filterParam) => {
        setloadingData(true);
        getStatCounter(RECUPERER_DATA_COUNTER, filterParam).then((res) => {
            setloadingData(false);
            setDataCounter(res.data)
            setDataRDV(res.data)
        }).catch((err) => {
            setloadingData(false)
        })
    }

    const recupereChiffreAffaire = (filterParam) => {

        getStat(RECUPERE_GRAPHE_CHIFFRE_AFFAIRE, 'application/json', filterParam).then((res) => {
            setGrapheChiffreAffaire(prev => ({
                ...prev,
                data: {
                    labels: res.data.labels,
                    datasets: [
                        {
                            label: "Chiffre d'affaire",
                            data: res.data.data,
                            backgroundColor: "#fbbf24",
                            borderColor: "white",
                            borderRadius: 3,
                            borderSkipped: false,
                        },
                    ]
                }
            }))
        }).catch((err) => {
        })
    }

    const recupereDataInstallation = (filterParam) => {

        getStat(RECUPERE_GRAPHE_INSTALLATION, 'application/json', filterParam).then((res) => {
            setGrapheInstallation(prev => ({
                ...prev,
                data: {
                    labels: res.data.labels,
                    datasets: [
                        {
                            label: "Nombre installation",
                            data: res.data.data,
                            backgroundColor: "#ccccc",
                            borderColor: "white",
                            borderRadius: 3,
                            borderSkipped: false,
                        },
                    ]
                }
            }))
        }).catch((err) => {

        })
    }

    const filterCounterDataByParam = (filter) => {
        const filterParam = {
            periode: filter.periode,
            mois: filter.mois,
            annee: filter.annee,
            dateDebut: filter.debut,
            dateFin: filter.fin
        }
        recupereCounterData(filterParam)
    }

    const filterChiffreAffaireByParam = (filter) => {
        const filterParam = {
            periode: filter.periode,
            mois: filter.mois,
            annee: filter.annee,
            dateDebut: filter.debut,
            dateFin: filter.fin,
            status: filter.status
        }
        recupereChiffreAffaire(filterParam)
    }

    const filterInstallationByParam = (filter) => {
        const filterParam = {
            periode: filter.periode,
            mois: filter.mois,
            annee: filter.annee,
            dateDebut: filter.debut,
            dateFin: filter.fin,
            status: filter.status
        }
        recupereDataInstallation(filterParam)
    }


    useEffect(() => {
        const date = new Date()

        const filterParam = {
            periode: "MOIS",
            mois: date.getMonth() + 1,
            annee: date.getFullYear(),
            dateDebut: "",
            dateFin: "",
            status: ""
        }

        store(COURBE, 'application/json', filterParam)

        recupereCounterData(filterParam)
        recupereChiffreAffaire(filterParam)
        recupereDataInstallation(filterParam)
    }, [])

    return (
        <div className="font-mtn">
            <div className="mb-8">
                <div className="lg:flex gap-x-2 ">
                    <h1 className="text-3xl font-extrabold text-black">
                        Tableau de board
                    </h1>
                    <DateFilter filtrerStatCounter={filterCounterDataByParam} />
                </div>
                {/* <p className="">Bienvenue {getUserProfil()?.nomPrenoms}</p> */}

                {!loadingData && dataCounter ? (
                    <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-2">
                        <Counter
                            bg={"bg-yello-300"}
                            color={"bg-[#d8e2fc]"}
                            label={"Chiffre d'affaire"}
                            count={(dataCounter?.paiemement?.montantTotal ?? "--") + " F CFA"}
                            text={""}
                            icon={<img src={client} alt="" className="w-6 h-6" />}
                        />
                        {/* <Counter
                            bg={"bg-red-300"}
                            color={"bg-[#f9e0e1]"}
                            label={"Agents"}
                            count={dataCounter?.abonnementStats?.statsAgent?.totalAgent}
                            text={"Rapport du mois " + dataCounter?.abonnementStats?.statsAgent?.totalAgentRapport}
                            icon={<img src={tech} alt="" className="w-6 h-6" />}
                        /> */}
                        <Counter
                            bg={"bg-indigo-300"}
                            color={"bg-indigo-100"}
                            label={"Intentions d'âchats"}
                            count={dataCounter?.abonnementStats?.stats?.totalAbonnement}
                            text={"Rapport du mois " + dataCounter?.abonnementStats?.rapport?.totalRapportAbonnement}
                            icon={<img src={calendar} alt="" className="w-6 h-6" />}
                        />
                        <Counter
                            bg={"bg-blue-300"}
                            link={`${HOME}/abonnements/TERMINER`}
                            label={"Clients connectés"}
                            count={dataCounter?.abonnementStats?.stats?.totalAbonnementTerminer}
                            text={"Rapport du mois " + dataCounter?.abonnementStats?.rapport?.totalRapportAbonnementTerminer}
                            icon={<img src={install} alt="" className="w-6 h-6" />}
                        />
                    </div>
                ) : !loadingData && !dataCounter ? (
                    <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-2">
                        <Counter
                            bg={"bg-yello-300"}
                            color={"bg-[#d8e2fc]"}
                            label={"Chiffre d'affaire"}
                            count={"0 F CFA"}
                            text={"Rapport du mois +0 F CFA"}
                            icon={<img src={client} alt="" className="w-6 h-6" />}
                        />
                        {/* <Counter
                            bg={"bg-red-300"}
                            color={"bg-[#f9e0e1]"}
                            label={"Agents"}
                            count={0}
                            text={"Rapport du mois +0"}
                            icon={<img src={tech} alt="" className="w-6 h-6" />}
                        /> */}
                        <Counter
                            bg={"bg-indigo-300"}
                            color={"bg-indigo-100"}
                            label={"Intentions d'âchats"}
                            count={0}
                            text={"Rapport du mois +0"}
                            icon={<img src={calendar} alt="" className="w-6 h-6" />}
                        />
                        <Counter
                            bg={"bg-blue-300"}
                            color={"bg-[#daeaea]"}
                            label={"Client connectés"}
                            count={0}
                            text={"Rapport du mois +0"}
                            icon={<img src={install} alt="" className="w-6 h-6" />}
                        />
                    </div>
                ) : (
                    <div className="mt-6 grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-4 gap-2">
                        <CounterSkeleton />
                        <CounterSkeleton />
                        <CounterSkeleton />
                        <CounterSkeleton />
                    </div>
                )}

                <Count loading={loadingData} counterData={dataRDV} />

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 2xl:grid-cols-2 gap-4">
                    <div>
                        <h1 className="text-md font-semibold">
                            Installations de la FTTH
                        </h1>
                        <div className="mt-2 bg-white border rounded-lg shadow-sm">
                            <div className=" bg-muted/50 gap-4 p-4">
                                <DateFilter filtrerInstallation={filterInstallationByParam} />
                            </div>
                            <Bar
                                className="mt-4 p-4"
                                height={180}
                                options={grapheInstallation.options}
                                data={grapheInstallation.data}
                            />
                        </div>
                    </div>

                    <div>
                        <h1 className="text-md font-semibold">
                            Chiffre d'affaire de la FTTH
                        </h1>
                        <div className="mt-2 bg-white border rounded-lg shadow-sm">
                            <div className="bg-muted/50 gap-4 p-4">
                                <DateFilter filtrerChiffreAffaire={filterChiffreAffaireByParam} />
                            </div>
                            <Bar
                                className="mt-4 p-4"
                                height={180}
                                options={grapheChiffreAffaire.options}
                                data={grapheChiffreAffaire.data}
                            />
                        </div>
                    </div>
                </div>
                {/* <GrapheGlobale /> */}
            </div>
        </div>
    );
};
